import React from 'react';
import { AcceptDeclineForm, Checkbox, CheckBoxParam, Row, SonForm, useForm } from '../../index';
import { AxiosResponse } from 'axios';
import { Hint } from '../../../components/Hint';

type DryRunAcceptDeclineFormProps = {
  form: SonForm<CheckBoxParam<'dryRun'>>;
  onSuccess?: (response: AxiosResponse) => void;
  headline: string;
  messageSuccess: string;
  messageSending: string;
  messageFail: string;
  customErrorTypeMessages?: Record<string, string>;
  hintMessage?: string;
  checkBoxLabel: string;
};

export function DryRunAcceptDeclineForm({
  form,
  onSuccess,
  headline,
  messageSuccess,
  messageSending,
  messageFail,
  customErrorTypeMessages,
  hintMessage,
  checkBoxLabel,
}: DryRunAcceptDeclineFormProps) {
  const { params } = useForm({ form, onSuccess });
  const dryRunParam = params.findByName('dryRun');

  return (
    <AcceptDeclineForm
      form={form}
      headline={headline}
      messageSuccess={messageSuccess}
      messageSending={messageSending}
      messageFail={messageFail}
      onSuccess={onSuccess}
      customErrorTypeMessages={customErrorTypeMessages}
    >
      {dryRunParam && (
        <>
          {hintMessage ? (
            <Row>
              <Hint message={hintMessage} />
            </Row>
          ) : null}
          <Row>
            <Checkbox label={checkBoxLabel} param={dryRunParam} />
          </Row>
        </>
      )}
    </AcceptDeclineForm>
  );
}
